export default "__VITE_ASSET__hJ0UMCmv__"